module.exports = __webpack_public_path__ + "static/img/DYLAN-PATTERSON.0042187.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DYLAN-PATTERSON.jpg
// module id = IqvY
// module chunks = 0